import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import '@/assets/css/reset.css';
import 'element-ui/lib/theme-chalk/index.css';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/ko';
import setFilters from './filters';

Vue.use(ElementUI, {locale});

Vue.config.productionTip = false;

Vue.prototype.$S3_PREFIX = process.env.VUE_APP_S3_PREFIX;

setFilters(Vue);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
